import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Copy, Link2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Row = ({ label, value, testid }) => (
  <div className="flex items-center gap-2 rounded-lg bg-slate-50 px-3 py-2">
    <span className="w-44 shrink-0 text-xs text-slate-500">{label}</span>
    <code dir="ltr" className="min-w-0 flex-1 truncate text-sm font-bold text-slate-800" data-testid={testid}>{value}</code>
    <button onClick={() => { navigator.clipboard?.writeText(value); toast.success("نُسخ"); }} className="rounded p-1 text-slate-400 hover:bg-white hover:text-blue-600" data-testid={`${testid}-copy`}><Copy className="h-3.5 w-3.5" /></button>
  </div>
);

export const PcRabet = () => {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/platform-console/rabet`).then((r) => setD(r.data)).catch(() => setD({ error: true })); }, []);
  if (!d || d.error) return null;
  const cb = `${window.location.origin}/api/rabet/callback`;
  return (
    <div className="rounded-2xl bg-white p-5 sm:p-6" data-testid="pc-rabet">
      <p className="flex items-center gap-2 font-heading font-bold"><Link2 className="h-4 w-4 text-blue-600" /> ربط حلول رابط (Rabet) — بيانات نموذج الاشتراك</p>
      <p className="mt-1 text-xs text-slate-500">انسخ هذه القيم كما هي في نموذج «البيانات» في بوابة rabet.sa.</p>
      <div className="mt-4 space-y-2">
        <Row label="اسم الجهة" value="WorkZone" testid="rabet-org" />
        <Row label="اسم الحقل لاسم المستخدم" value={d.user_field} testid="rabet-user-field" />
        <Row label="قيمة اسم المستخدم" value={d.username} testid="rabet-user" />
        <Row label="اسم الحقل للرمز السري" value={d.pass_field} testid="rabet-pass-field" />
        <Row label="الرمز السري" value={d.password} testid="rabet-pass" />
        <Row label="Callback URL" value={cb} testid="rabet-callback" />
      </div>
      <p className="mt-3 text-xs text-slate-500">البيانات المستلمة من رابط: <b data-testid="rabet-count">{d.count}</b>{d.recent?.[0] && ` — آخرها ${d.recent[0].at.slice(0, 16).replace("T", " ")}`}</p>
      {d.recent?.length > 0 && <pre dir="ltr" className="mt-2 max-h-48 overflow-auto rounded-lg bg-slate-900 p-3 text-[11px] text-slate-100" data-testid="rabet-recent">{JSON.stringify(d.recent[0].payload, null, 2)}</pre>}
    </div>
  );
};
